document.addEventListener("DOMContentLoaded", function () {
  const wheelSpokes = document.querySelector('.custom-wheel-spokes');
  const spinButton = document.querySelector('.custom-spin-btn');
  const wheel = document.querySelector('.custom-wheel');
  const indicator = document.querySelector('.custom-wheel-indicator');
  let isSpinning = false;
  let spinAngle = 0;

  // Initialize wheel with dynamic prize slices based on collection data
  const initializeWheel = () => {
    const collections = window.collectionData; // Use global collection data

    const numPrizes = collections.length; // Total number of prizes
    const anglePerPrize = 360 / numPrizes;
    let currentAngle = 0;

    collections.forEach((collection, index) => {
      const prize = document.createElement('li');
      prize.classList.add('custom-wheel-slice', 'prize');
      prize.style.transform = `rotate(${currentAngle}deg)`; // Rotate each slice accordingly
      prize.style.transformOrigin = "100% 100%"; // Ensure slices rotate from the center of the wheel

      // Add collection name as text inside each slice
      const prizeText = document.createElement('span');
      prizeText.classList.add('custom-wheel-text');
      prizeText.textContent = collection.name;
      prize.appendChild(prizeText);

      // Append prize slice to wheel
      wheelSpokes.appendChild(prize);
      currentAngle += anglePerPrize; // Increment angle for next slice
    });
  };

  // Spin the wheel
  const handleSpin = () => {
    if (isSpinning) return;

    isSpinning = true;
    const randomSpin = Math.floor(Math.random() * 5000 + 2000); // Random spin duration
    spinAngle += randomSpin;

    wheel.style.transition = "transform 6s ease-out";
    wheel.style.transform = `rotate(${spinAngle}deg)`; // Apply rotation


    spinButton.setAttribute('disabled', 'true');
  };

  // Handle when the wheel finishes spinning
  const onWheelTransitionEnd = () => {
    isSpinning = false;
    spinButton.removeAttribute('disabled');

    // Re-show the indicator
    indicator.style.display = 'block';

    const finalAngle = spinAngle % 360;
    const winningPrizeIndex = Math.floor(finalAngle / (360 / window.collectionData.length));

    const winningPrize = window.collectionData[winningPrizeIndex];
    alert(`Congratulations! You won: ${winningPrize.name}`);
  };

  // Initialize the wheel when page is loaded
  initializeWheel();

  // Event listeners
  wheel.addEventListener('transitionend', onWheelTransitionEnd);
  spinButton.addEventListener('click', handleSpin);
});
